import { render, staticRenderFns } from "./RegistrationsArchiveList.vue?vue&type=template&id=06bafaea"
import script from "./RegistrationsArchiveList.vue?vue&type=script&lang=js"
export * from "./RegistrationsArchiveList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports